import { Col, ListGroupItem, Row } from 'reactstrap'
import '../Chats/style.css'
import { useSelector } from 'react-redux'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { updateConversationReadStatus } from 'store/Chats/actions'
import defaultAvatar from '../../../assets/img/brand/img_avatar.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUsers } from '@fortawesome/free-solid-svg-icons'
import { updateGroupConversationReadStatus } from 'store/Chats/actions'

export default function ConversationHeader({ conversation, isActive }) {
  const dispatch = useDispatch()
  const { user } = useSelector((store) => store.auth)

  useEffect(() => {
    if (
      isActive &&
      conversation?.last_message_sender !== user?.id &&
      !conversation?.last_message_read &&
      !conversation?.is_group
    ) {
      dispatch(updateConversationReadStatus(conversation?.id))
    }
  }, [
    conversation?.id,
    dispatch,
    conversation?.last_message_read,
    conversation?.last_message_sender,
    user?.id,
    isActive,
    conversation?.is_group,
  ])

  useEffect(() => {
    if (
      isActive &&
      conversation?.last_message_sender !== user?.id &&
      !conversation?.last_message_read &&
      conversation?.is_group
    ) {
      dispatch(updateGroupConversationReadStatus(conversation?.id))
    }
  }, [
    conversation?.id,
    dispatch,
    conversation?.last_message_read,
    conversation?.last_message_sender,
    user?.id,
    isActive,
    conversation?.is_group,
  ])

  return (
    <ListGroupItem
      className={`chatContainer radius10 list-group-item-action ${
        isActive ? 'active' : ''
      }`}
      style={{ borderRadius: '10px' }}
    >
      <Row className='align-items-center'>
        <Col className='col-auto'>
          {!conversation?.is_group ? (
            <img
              alt='...'
              className='avatar rounded-circle'
              src={
                JSON.parse(conversation?.message_user)?.avatar
                  ? JSON.parse(conversation?.message_user)?.avatar?.url
                  : defaultAvatar
              }
            />
          ) : (
            <>
              {conversation?.group_image ? (
                <img
                  className='avatar rounded-circle'
                  alt=''
                  src={conversation?.group_image}
                />
              ) : (
                <FontAwesomeIcon icon={faUsers} size='lg' className='mx-1' />
              )}
            </>
          )}
        </Col>
        <div className='col ml--2'>
          <div className='d-flex justify-content-between align-items-center'>
            <div>
              <h4 className='mb-0 text-sm'>
                {!conversation?.is_group ? (
                  <>
                    {JSON.parse(conversation?.message_user)?.first_name}{' '}
                    {JSON.parse(conversation?.message_user)?.last_name}
                  </>
                ) : (
                  conversation?.group_name
                )}
              </h4>
            </div>
            {conversation?.last_message_read === 0 &&
              conversation?.last_message_sender !== user?.id && (
                <span
                  className='dot top-0 start-100 translate-middle'
                  style={{
                    width: '10px',
                    height: '10px',
                    borderRadius: '50%',
                    backgroundColor: '#00d4ff',
                    border: '2px solid white',
                  }}
                ></span>
              )}
          </div>
          <p className={`text-sm mb-0 ${isActive ? 'text-secondary' : ''}`}>
            {conversation?.is_group && conversation?.last_message_text
              ? JSON.parse(conversation?.message_user)?.user_id !== user.id
                ? `${JSON.parse(conversation?.message_user)?.first_name}: `
                : 'You: '
              : ''}
            {conversation?.last_message_text?.length > 35
              ? `${conversation?.last_message_text?.slice(0, 35)}...`
              : conversation?.last_message_text}
          </p>
        </div>
      </Row>
    </ListGroupItem>
  )
}
